<template>
  <div class="oct-user-form oct-grid">
    <div class="oct-grid__row">
      <!-- Items -->
      <div class="oct-grid__col oct-grid__col--12">
        <oct-section-header
          :title="type.replace('prs', 'Press Releases').toUpperCase()"
          :separate="false"
        />
 
        <oct-card-list>
          <oct-card-list-item>
            <oct-add-circle :action="{href: `${path}/${singular}/${params}`}" />
          </oct-card-list-item>

          <oct-card-list-item
            v-for="(item, i) in items"
            :key="i"
          >
            <oct-card
              :media="{
                image: item.images[0],
                lock: item.status === 'private'
              }"
              :href="`${path}/${singular}/#${item.id}`"
              :title="getTitle(item)"
              :headline="getHeadline(item)"
              :text="getText(item)"
            >
            </oct-card>
          </oct-card-list-item>
        </oct-card-list>
      </div>
    </div>
  </div>
</template>

<script>
import OctPrototypeForm from '@/components/prototype-form/OctPrototypeForm.js'
import OctCardList from '@/components/card/OctCardList.vue';
import OctCardListItem from '@/components/card/OctCardListItem.vue';
import OctCard from '@/components/card/OctCard.vue';
import OctAddCircle from '@/components/add-circle/OctAddCircle.vue';
import OctSectionHeader from '@/components/section-header/OctSectionHeader.vue';

export default {
  name: 'OctItemList',
  mixins: [OctPrototypeForm],
  components: {
    OctCardList,
    OctCardListItem,
    OctCard,
    OctAddCircle,
    OctSectionHeader
  },
  props: {
    /** Items to display */
    items: {
      type: Array,
      default: () => []
    },
    /** User's exhibitions */
    type: {
      type: String,
      default: 'artworks'
    },
    /** Auth0 access token */
    token: {
      type: String,
      default: ''
    }
  },
  computed: {
    singular () {
      return /^(mailmagazine|information)$/.test(this.type) ? 'mailnews/edit' :
        (this.type === 'news' ? 'news' : this.type.replace(/s$/, ''))
    },
    path () {
      return /^(mailmagazine|information)$/.test(this.type) ? '/account/management' : '/account'
    },
    /** Query parameters */
    params () {
      return /^information$/.test(this.type) ? '?type=information' : ''
    },
  },
  methods: {
    getTitle (item) {
      const settings = {
        artworks: '',
        mailmagazine: '',
        information: '',
      }

      return settings[this.type] !== undefined ? settings[this.type] : `Exhibition: ${item.type}`
    },
    getHeadline (item) {
      if (this.type === 'exhibitions') {
        return this.getLocaleString(item, 'title') + '\n' +
                this.dateToString(new Date(item.startDate))
      } else {
        return this.getLocaleString(item, 'title')
      }
    },
    getText (item) {
      if (this.type === 'artworks') {
        return `${item.publishedAt} / ${item.materials.join(', ')}`
      } else if (this.type === 'exhibitions') {
        return this.getLocaleString(item['gallery'], 'tradeName')
      } else if (this.type === 'prs') {
        return item.publishedAt ? this.dateToString(new Date(item.publishedAt)) : ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

</style>
